import { render, staticRenderFns } from "./PoiMarker.vue?vue&type=template&id=4834da3c&scoped=true"
import script from "./PoiMarker.vue?vue&type=script&lang=js"
export * from "./PoiMarker.vue?vue&type=script&lang=js"
import style0 from "./PoiMarker.vue?vue&type=style&index=0&id=4834da3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834da3c",
  null
  
)

export default component.exports